import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { includes, isEmpty } from 'ramda';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader, ContactFeedback } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import { useIgnoreErrorsWhen } from 'components/molecules/ComponentLoader/hooks';
import { CONTACT_NOT_FOUND_ERR_MSG } from 'features/views/contactDetail/constants';

export const Feedback = ({ contact, handleReload, handleFeedbackSuccess, fetchStorePath }) => {
	const ignoreErrorsForContactDetailNotFound = useIgnoreErrorsWhen({
		fetchStorePath,
		attributePath: ['metaData', 'parsedContent', 'message'],
		condition: (value) => includes(CONTACT_NOT_FOUND_ERR_MSG, value),
	});

	return (
		<ComponentLoader
			onReload={handleReload}
			fetchStorePath={fetchStorePath}
			ignoreErrors={ignoreErrorsForContactDetailNotFound}
		>
			<Stack spacing={2}>
				<SectionHeader text={getLabelMessage('contactDetail:feedbackTitle')} />
				{!isEmpty(contact) && <ContactFeedback contact={contact} onSuccess={handleFeedbackSuccess} />}
			</Stack>
		</ComponentLoader>
	);
};

Feedback.propTypes = {
	contact: PropTypes.object,
	fetchStorePath: PropTypes.string,
	handleFeedbackSuccess: PropTypes.func,
	handleReload: PropTypes.func,
};

export default Feedback;
